import AddCardModal from "../../Profile/AddCardModal/AddCardModal";
import { RootState } from "../../../../Redux/store";
import styles from "./SelectCard.module.scss";
import { useSelector } from "react-redux";
import React, { useState } from "react";

interface Props {
  selectedCard: string;
  setSelectedCard: React.Dispatch<React.SetStateAction<string>>;
}

function SelectCard(props: Props) {
  const { selectedCard, setSelectedCard } = props;
  const { profileData } = useSelector((state: RootState) => state.profile);
  const [addNewCardModalOpen, setAddNewCardModalOpen] = useState(false);

  return (
    <React.Fragment>
      <AddCardModal
        isOpen={addNewCardModalOpen}
        setIsOpen={setAddNewCardModalOpen}
      />

      <div className={styles.mainContainer}>
        <div className={styles.headingContainer}>
          <p className={styles.label}>Create Booking</p>
        </div>
        <div className={styles.selectCardBodyContainer}>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Select Card</p>
            <select
              className={styles.input}
              value={selectedCard}
              onChange={(e) => setSelectedCard(e.target.value)}
            >
              {!selectedCard && <option value="">Select Card</option>}
              {profileData?.memberCCInfo?.map((card: any, i: number) => (
                <option key={i} value={card?.id}>
                  XXX - {card?.cardNumber}
                </option>
              ))}
            </select>
          </div>
          <div className={styles.buttonContainer}>
            <button
              className={styles.button}
              onClick={() => setAddNewCardModalOpen(true)}
            >
              Add new card
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default SelectCard;
